import { PositionType } from "@habity/types";

export const STOCKHOLM_LOCATION: PositionType = {
  longitude: 18.06324,
  latitude: 59.334591,
};

export const LOCATIONIQ_DEFAULT_CONFIG = {
  LANGUAGE: "sv",
  COUNTRY_CODES: "se",
  NORMALIZE_CITY: 1,
  NORMALIZE_ADDRESS: 1,
  EXTRA_TAGS: 1,
  IMPORTANCE_SORT: 1,
  DEDUPE: 1,
  LIMIT: 10,
  LIMIT_AUTOCOMPLETE: 20,
  TAGS: "place:state,place:region,place:province,place:municipality,place:suburb,place:village,highway:residential,highway:tertiary,highway:unclassified,landuse:residential,boundary:administrative",
  NEARBY_TAGS:
    "all,!landuse:*,!building:*,!boundary:*,!highway:*,!office:*,!tourism:*,!historic:*,!amenity:vending_machine",
  NEARBY_RADIUS: 5000,
  NEARBY_LIMIT: 30,
  NEARBY_VERSION: 1.2,
};
